let getters = {

    getLayout (state) {
        return state.layout
    },
};

export default getters
